/** Tabler icon classes used on home quick tiles (without `ti` prefix). */
export const HOME_TOPIC_TILE_ICONS: Record<string, string> = {
  towing: 'ti-tir',
  'roadside-assist': 'ti-car-crash',
  'accident-help': 'ti-ambulance',
  'vehicle-lockout': 'ti-lock-open',
  'traffic-ticket': 'ti-ticket',
  'legal-consult': 'ti-phone-call',
  'fraud-disputes': 'ti-gavel',
  immigration: 'ti-plane-departure',
  'tax-services': 'ti-receipt',
  insurance: 'ti-shield-check',
  'business-services': 'ti-briefcase',
  'financial-svcs': 'ti-chart-line',
  'buy-vehicle': 'ti-car',
  'sell-vehicle': 'ti-cash',
  financing: 'ti-credit-card',
  'trade-in': 'ti-arrows-exchange',
  rcic: 'ti-certificate',
  lawyers: 'ti-gavel',
  accountants: 'ti-calculator',
  paralegals: 'ti-file-text',
};

export const HOME_SECTION_TILE_ICONS: Record<string, string> = {
  emergency: 'ti-alert-triangle',
  legal: 'ti-scale',
  financial: 'ti-receipt',
  vehicle: 'ti-car',
  professionals: 'ti-users',
};

export function homeTopicIconForSlug(slug: string, categoryId?: string): string {
  return (
    HOME_TOPIC_TILE_ICONS[slug] ??
    (categoryId ? HOME_SECTION_TILE_ICONS[categoryId] : undefined) ??
    'ti-point'
  );
}

export function homeTopicIconForItem(
  slug: string,
  categoryId?: string,
  iconKey?: string | null,
): string {
  const fromKey = iconKey?.trim().replace(/^ti-/i, '');
  if (fromKey) return `ti-${fromKey}`;
  return homeTopicIconForSlug(slug, categoryId);
}
